import { Button } from "@arcadeai/design-system/components/ui/atoms/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@arcadeai/design-system/components/ui/atoms/tooltip";
import { LayoutList } from "lucide-react";
import {
  type ResourceViewType,
  useResourceViewStore,
} from "./hooks/use-resource-view";

type ResourceViewSwitcherProps = {
  className?: string;
};

export const ResourceViewSwitcher = ({
  className,
}: ResourceViewSwitcherProps) => {
  const { viewType, setViewType } = useResourceViewStore();

  const handleViewChange = (newViewType: ResourceViewType) => {
    setViewType(newViewType);
  };

  return (
    <div
      className={`inline-flex rounded-md border bg-background p-0.5 ${className}`}
    >
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger
            render={
              <Button
                className={`h-8 px-2 transition-colors ${
                  viewType === "vertical"
                    ? "bg-muted text-foreground"
                    : "bg-transparent text-muted-foreground hover:text-foreground"
                }`}
                onClick={() => handleViewChange("vertical")}
                size="sm"
                variant="ghost"
              />
            }
          >
            <LayoutList className="size-4" />
          </TooltipTrigger>
          <TooltipContent>
            <p>Vertical view</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>

      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger
            render={
              <Button
                className={`h-8 px-2 transition-colors ${
                  viewType === "horizontal"
                    ? "bg-muted text-foreground"
                    : "bg-transparent text-muted-foreground hover:text-foreground"
                }`}
                onClick={() => handleViewChange("horizontal")}
                size="sm"
                variant="ghost"
              />
            }
          >
            <svg
              className="size-5 text-foreground"
              fill="currentColor"
              height="200"
              viewBox="0 0 24 24"
              width="200"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>Horizontal view</title>
              <g fill="none" stroke="currentColor" strokeWidth="1.5">
                <path
                  d="M22 8h-6.5M9 4v4h6.5m0 0V4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path d="M2 17.714V6.286C2 5.023 2.995 4 4.222 4h15.556C21.005 4 22 5.023 22 6.286v11.428C22 18.977 21.005 20 19.778 20H4.222C2.995 20 2 18.977 2 17.714Z" />
              </g>
            </svg>
          </TooltipTrigger>
          <TooltipContent>
            <p>Horizontal view</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
};
